import { render, staticRenderFns } from "./storageForm.vue?vue&type=template&id=733d2525"
import script from "./storageForm.vue?vue&type=script&lang=js"
export * from "./storageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports